// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-editor-container {
  -webkit-box-sizing: border-box !important;
          box-sizing: border-box !important;
  overflow: visible !important;
}

.description-editor-container [contenteditable] {
  outline: none !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
}

.narrative-ocg-editor {
  background: #fff;
  border: 1px solid #865bdf;
  border-radius: 10px;
  -webkit-box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.3),
    0 2px 6px 2px rgba(0, 0, 0, 0.15);
          box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.3),
    0 2px 6px 2px rgba(0, 0, 0, 0.15);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #333;
  overflow: hidden;
  position: relative;
}

/* The grid editor is already outlined by the purple narrative border. Remove
   the Kendo Popup chrome and the editor shadow so it does not render a second,
   gray frame around that border. */
.narrative-editor-popup.k-popup {
  background: transparent;
  border: 0;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.narrative-editor-popup .narrative-ocg-editor {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.narrative-ocg-editor--error {
  border-color: #b3261e;
}

.narrative-ocg-editor--warning {
  border-color: #ffa007;
}

.narrative-ocg-editor__topbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  padding: 4px 8px 0;
}

.narrative-ocg-icon-button {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: transparent;
  border: 0;
  color: #333;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 16px;
  height: 24px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  line-height: 1;
  padding: 0;
  width: 24px;
}

.narrative-ocg-editor__field {
  background: #fff;
  border: 0;
  border-radius: 4px;
  margin: 12px 12px 0;
  min-height: 180px;
  padding: 10px;
  position: relative;
}

.narrative-ocg-editor__loading {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: inherit;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.narrative-ocg-editor__loading img {
  display: block;
  height: 120px;
  width: 120px;
}

.narrative-ocg-editor__loading-text {
  color: #141414;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 30px;
}

.narrative-ocg-editor__field .editor-content {
  border: 0 !important;
  font-size: 14px !important;
  letter-spacing: 0 !important;
  line-height: 1.42 !important;
  min-height: 160px !important;
  padding: 0 !important;
}

.narrative-ocg-editor__toolbar {
  padding: 0 12px 4px;
}

.narrative-ocg-editor__toolbar-row {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 36px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 4px 8px;
}

.narrative-ocg-editor__toolbar-left,
.narrative-ocg-editor__toolbar-right {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.narrative-ocg-editor__toolbar-left {
  gap: 16px;
  min-width: 0;
}

.narrative-ocg-badges {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 6px;
}

.narrative-ocg-badge {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  backdrop-filter: blur(3px);
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 10px;
  font-weight: 400;
  height: 22px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  letter-spacing: 0.5px;
  line-height: 1.6;
  padding: 3px 7px;
  white-space: nowrap;
}

.narrative-ocg-badge .k-button-text > span {
  border-bottom: 1px solid #fff;
  line-height: 1.2;
}

.narrative-ocg-badge--error {
  background: #b3261e !important;
  border-color: #b3261e !important;
  color: #fff;
}

.narrative-ocg-badge--warning {
  background: #ffa007 !important;
  border-color: #ffa007 !important;
  color: #fff;
}

.narrative-ocg-panel {
  border-bottom: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  -webkit-box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 0 -1px -1px;
  min-height: 125px;
  padding: 10px 20px 18px;
  position: relative;
}

.narrative-ocg-panel--ai {
  background: #f4f2ff;
  color: #865bdf;
}

.narrative-ocg-panel--error {
  background: #f5f5f5;
  border-color: #b3261e;
  color: #b3261e;
}

.narrative-ocg-panel--warning {
  background: #f5f5f5;
  border-color: #ffa007;
  color: #ffa007;
}

.narrative-ocg-panel--checking {
  background: #f7f7f7;
  color: #333;
}

.narrative-ocg-panel--error::before,
.narrative-ocg-panel--warning::before {
  background: currentColor;
  content: '';
  height: 17px;
  left: 3px;
  position: absolute;
  top: 9px;
  width: 2px;
}

.narrative-ocg-panel__title {
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.5px;
  margin-bottom: 0;
}

.narrative-ocg-panel__message {
  color: #333;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 8px;
}

.narrative-ocg-panel__body {
  color: #333;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 16px;
  min-height: 32px;
  max-height: 100px;
  white-space: pre-wrap;
  overflow: auto;
  overflow-x: hidden;
}

.narrative-ocg-diff--removed {
  color: #ca2921;
  font-weight: 700;
  text-decoration: line-through;
}

.narrative-ocg-diff--added {
  color: #339858;
  font-weight: 700;
}

.narrative-ocg-panel__footer {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-top: 10px;
}

.narrative-ocg-panel__view-switch {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #fafafa;
  border-radius: 34.286px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 8px;
  height: 26px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 0 10px;
  width: 69px;
}

.narrative-ocg-panel__view-button {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 0;
  width: 14px;
}

.narrative-ocg-panel__view-button img {
  display: block;
  height: 14px;
  width: 14px;
}

.narrative-ocg-panel__view-divider {
  background: #cac4d0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 6px;
  width: 1px;
}

.narrative-ocg-panel__actions .k-button-text {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.narrative-ocg-panel__actions {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 8px;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.narrative-ocg-action {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 14px;
  font-weight: 400;
  gap: 6px;
  height: 32px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  letter-spacing: 0.1px;
  line-height: 1.42;
  min-width: 78px;
  padding: 0 17px;
  white-space: nowrap;
}

.narrative-ocg-action:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.narrative-ocg-action--loading {
  opacity: 0.75;
}

.narrative-ocg-action--secondary {
  background: #fff;
  border-color: #d9d9d9;
  color: #333;
}

.narrative-ocg-action--primary {
  background: #333;
  color: #fff;
  letter-spacing: 0.25px;
  min-width: 78px;
  padding: 0 12px 2px;
}

.narrative-ocg-validation-bars {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

.narrative-ocg-validation-bar {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  gap: 10px;
  height: 38px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  letter-spacing: 0.25px;
  line-height: 20px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  padding: 10px 20px;
  width: 100%;
}

.narrative-ocg-validation-bar--error {
  background: #dd352c;
}
.narrative-ocg-validation-bar--warning {
  background: #ffa007;
}

.narrative-ocg-validation-bar__icon {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 16px;
          flex: 0 0 16px;
  height: 16px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: relative;
  width: 16px;
}

.narrative-ocg-validation-bar__icon img {
  height: 16px;
  inset: 0;
  position: absolute;
  width: 16px;
}

.narrative-ocg-validation-bar__divider {
  background: rgba(255, 255, 255, 0.8);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  height: 20px;
  width: 1px;
}

.narrative-ocg-validation-bar > strong {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  font-weight: 600;
  white-space: nowrap;
}

.narrative-ocg-validation-bar__rule-container {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 0px;
          flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.narrative-ocg-validation-bar__rule {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.narrative-ocg-validation-bar__view {
  background: #fff !important;
  border: 0 !important;
  border-radius: 999px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #141414 !important;
  cursor: pointer;
  display: grid;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 400 !important;
  height: 26px;
  letter-spacing: normal;
  line-height: 16px !important;
  min-width: 70px !important;
  padding: 0 12px !important;
  place-items: center;
  text-align: center;
  white-space: nowrap;
  width: 70px;
}

.narrative-ocg-validation-bar__view:hover,
.narrative-ocg-validation-bar__view:focus {
  background: #fff !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.narrative-ocg-field-suggestion {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  position: absolute;
  right: 28px;
  top: 8px;
  z-index: 10;
}

.narrative-ocg-field-suggestion__trigger {
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  height: 24px;
  outline: none;
  padding: 3px;
  width: 24px;
}

.narrative-ocg-field-suggestion__trigger:hover,
.narrative-ocg-field-suggestion__trigger:focus,
.narrative-ocg-field-suggestion__trigger:active {
  background: transparent;
  -webkit-box-shadow: none;
          box-shadow: none;
  outline: none;
}

.narrative-ocg-field-suggestion__trigger img {
  height: 18px;
  width: 18px;
}

.narrative-ocg-field-suggestion__icon--hover {
  display: none;
}

.narrative-ocg-field-suggestion__trigger:hover
  .narrative-ocg-field-suggestion__icon--default,
.narrative-ocg-field-suggestion__trigger:focus
  .narrative-ocg-field-suggestion__icon--default {
  display: none;
}

.narrative-ocg-field-suggestion__trigger:hover
  .narrative-ocg-field-suggestion__icon--hover,
.narrative-ocg-field-suggestion__trigger:focus
  .narrative-ocg-field-suggestion__icon--hover {
  display: block;
}

.narrative-ocg-field-suggestion__popover {
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  color: #333;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 16px;
  left: -73px;
  min-width: 250px;
  padding: 26px;
  position: absolute;
  top: 32px;
  z-index: 1000;
}

.narrative-ocg-field-suggestion__popover strong {
  color: #b3261e;
}
.narrative-ocg-field-suggestion__values span {
  color: #ca2921;
  text-decoration: line-through;
}
.narrative-ocg-field-suggestion__values b {
  color: #339858;
}

.narrative-ocg-field-suggestion__accept {
  -ms-flex-item-align: end;
      align-self: flex-end;
  -webkit-box-flex: 0 !important;
      -ms-flex: 0 0 auto !important;
          flex: 0 0 auto !important;
  height: 32px !important;
  min-height: 32px !important;
  min-width: 104px;
  padding: 0 17px !important;
  width: auto !important;
}

.narrative-ocg-field-suggestion__accept-icon {
  display: block;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 16px;
          flex: 0 0 16px;
  height: 16px !important;
  width: 16px !important;
}

.narrative-ocg-dialog-backdrop {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: rgba(0, 0, 0, 0.2);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  inset: 0;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 20px;
  position: fixed;
  z-index: 20000;
}

.narrative-ocg-details-dialog {
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.3),
    0 4px 8px 3px rgba(0, 0, 0, 0.15);
          box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.3),
    0 4px 8px 3px rgba(0, 0, 0, 0.15);
  max-height: calc(100vh - 40px);
  max-width: calc(100vw - 40px);
  overflow: hidden;
  width: 720px;
}

.narrative-ocg-details-dialog--maximized {
  border-radius: 0;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  width: 100vw;
}

.narrative-ocg-details-dialog__icon-button {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 40px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 12px;
  width: 40px;
}

.narrative-ocg-details-dialog__icon-button img {
  display: block;
  height: 16px;
  width: 16px;
}

.narrative-ocg-reference-window .k-window-title {
  width: 100%;
}

.custom-floating-window.k-window {
  /* Drop Kendo's default 1px #dee2e6 window border; the shadow frames it. */
  border: 0;
  max-height: 100vh;
  max-width: 100vw;
}

.custom-floating-window.k-window .k-window-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0;
}

.custom-floating-window__body {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-height: 0;
}

.custom-floating-window-title {
  width: 100%;
}

.custom-floating-window-actions {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 0;
}

.custom-floating-window-action {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 40px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 0;
  width: 40px;
}

.custom-floating-window-action img {
  display: block;
  height: 16px;
  width: 16px;
}

.narrative-ocg-details-dialog__content {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  min-height: 387px;
  overflow: auto;
  padding: 24px 22px;
}

.narrative-ocg-details-dialog--maximized
  .narrative-ocg-details-dialog__content {
  height: calc(100vh - 80px);
  min-height: 0;
}

.narrative-ocg-detail-item {
  color: #141414;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 1.42;
  margin-bottom: 12px;
}

.narrative-ocg-detail-item__description {
  padding-left: 10px;
}

.narrative-ocg-mobile-screen .narrative-ocg-detail-item {
  color: #141414;
  font-family: 'Segoe UI', sans-serif;
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 1.35;
  margin-bottom: 16px;
}

.narrative-ocg-mobile-screen .narrative-ocg-detail-item__description {
  padding-left: 10px;
}

.narrative-ocg-mobile-screen .narrative-ocg-summary-content,
.narrative-ocg-mobile-screen .narrative-ocg-summary-rule {
  color: #333;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 1.5;
}

.narrative-ocg-summary-content {
  color: #333;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.narrative-ocg-summary-empty {
  color: #666;
  font-size: 14px;
  line-height: 1.42;
  padding-top: 50px;
  text-align: center;
}

.narrative-ocg-summary-rules {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.narrative-ocg-summary-rule {
  color: #141414;
  font-size: 14px;
  line-height: 1.5;
}

.narrative-ocg-summary-rule__name {
  font-weight: 700;
}

.narrative-ocg-summary-rule__condition {
  margin-top: 2px;
}

.narrative-ocg-mobile-screen {
  background: #f8f9ff;
  color: #141414;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  inset: 0;
  position: fixed;
  z-index: 2147483600;
}

.narrative-ocg-mobile-screen__header {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 96px;
          flex: 0 0 96px;
  height: 96px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 0 24px 16px;
  position: relative;
}

.narrative-ocg-mobile-screen--reference .narrative-ocg-mobile-screen__header {
  background: #865bdf;
}

.narrative-ocg-mobile-screen--error .narrative-ocg-mobile-screen__header {
  background: #b3261e;
}

.narrative-ocg-mobile-screen--warning .narrative-ocg-mobile-screen__header {
  background: #ffa007;
}

.narrative-ocg-mobile-screen__title {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  color: #fff;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-family: 'Segoe UI', sans-serif;
  font-size: 24px;
  font-weight: 600;
  gap: 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  left: 56px;
  line-height: 32px;
  min-width: 0;
  position: absolute;
  right: 56px;
  top: 48px;
}

.narrative-ocg-mobile-screen__title img {
  display: block;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  height: 24px;
  width: 24px;
}

.narrative-ocg-mobile-screen__title span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.narrative-ocg-mobile-screen__close {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 32px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: absolute;
  right: 24px;
  top: 48px;
  width: 32px;
}

.narrative-ocg-mobile-screen__close img {
  display: block;
  -webkit-filter: brightness(0) invert(1);
          filter: brightness(0) invert(1);
  height: 32px;
  width: 32px;
}

.narrative-ocg-mobile-screen__body {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 16px 24px;
  -webkit-overflow-scrolling: touch;
}

.narrative-ocg-mobile-document {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 16px;
  height: 100%;
  min-height: 0;
}

.narrative-ocg-mobile-document__preview {
  background: #fff;
  border: 0;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  width: 100%;
}

.narrative-ocg-mobile-document__preview .k-pdf-viewer {
  border: 0;
  height: 100%;
}

.narrative-ocg-mobile-document__preview .k-pdf-viewer-canvas {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  height: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.narrative-ocg-mobile-document__preview .k-pdf-viewer-canvas,
.narrative-ocg-mobile-document__preview .k-pdf-viewer-pages {
  min-height: 0;
}

.narrative-ocg-mobile-document__download {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #fff;
  border: 1px solid #dadada;
  border-radius: 24px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #333;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 48px;
          flex: 0 0 48px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 16px;
  font-weight: 400;
  height: 48px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  line-height: normal;
  text-decoration: none;
  width: 100%;
}

.narrative-ocg-editor--mobile {
  border-color: #e8e8e8 !important;
  border-radius: 6px;
  -webkit-box-shadow: none;
          box-shadow: none;
  overflow: visible;
  width: 100%;
}

.narrative-ocg-editor--mobile:focus-within {
  -webkit-box-shadow: 0 4px 7.5px rgba(0, 0, 0, 0.2);
          box-shadow: 0 4px 7.5px rgba(0, 0, 0, 0.2);
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__field {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 8px 8px 0;
  min-height: 137px;
  padding: 16px;
}

.narrative-ocg-editor--mobile:not(.narrative-ocg-editor--error):not(
    .narrative-ocg-editor--warning
  ):focus-within
  .narrative-ocg-editor__field {
  border-color: #865bdf;
}

.narrative-ocg-editor--mobile.narrative-ocg-editor--error
  .narrative-ocg-editor__field {
  border-color: #b3261e;
}

.narrative-ocg-editor--mobile.narrative-ocg-editor--warning
  .narrative-ocg-editor__field {
  border-color: #ffa007;
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__field textarea,
.narrative-ocg-editor--mobile .narrative-ocg-editor__field .k-input-inner,
.narrative-ocg-editor--mobile .narrative-ocg-editor__field .editor-content {
  font-size: 16px !important;
  letter-spacing: 0 !important;
  line-height: normal !important;
  min-height: 103px !important;
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar {
  padding: 10px 24px;
  position: relative;
  z-index: 1;
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-row {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 22px;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  min-height: 22px;
  padding: 0;
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-left {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
}

.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-right {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-left: auto;
}

.narrative-ocg-editor--mobile .narrative-ocg-badges {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel {
  border-color: #e8e8e8;
  border-radius: 0 0 6px 6px;
  -webkit-box-shadow: 0 4.36px 4.36px rgba(0, 0, 0, 0.1);
          box-shadow: 0 4.36px 4.36px rgba(0, 0, 0, 0.1);
  margin: 0;
  min-height: 125px;
  padding: 16px 24px;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel::before {
  height: 19px;
  left: 3px;
  top: 16px;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel__title {
  font-size: 14px;
  letter-spacing: 0;
  line-height: normal;
  margin-bottom: 0;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel__body {
  font-size: 12px;
  line-height: 1.33;
  min-height: 32px;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel__footer--mobile {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
      -ms-flex-direction: row !important;
          flex-direction: row !important;
  gap: 12px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-top: 8px;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel__actions--mobile {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-pack: end !important;
      -ms-flex-pack: end !important;
          justify-content: flex-end !important;
  width: auto !important;
}

.narrative-ocg-editor--mobile .narrative-ocg-panel__icon-actions {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}

.narrative-ocg-editor--mobile
  .narrative-ocg-panel__actions--mobile
  .narrative-ocg-action {
  -webkit-box-flex: 0 !important;
      -ms-flex: 0 0 78px !important;
          flex: 0 0 78px !important;
}

.narrative-ocg-mobile-icon-action img {
  display: block;
  max-height: 16px;
  max-width: 16px;
}

@media (max-width: 640px) {
  .narrative-ocg-editor__toolbar-row {
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    height: auto;
    min-height: 36px;
  }

  .narrative-ocg-editor__toolbar-left {
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 8px;
  }

  .narrative-ocg-panel {
    padding: 10px 16px 16px 20px;
  }

  .narrative-ocg-panel__footer {
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .narrative-ocg-panel__actions {
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    width: 100%;
  }

  .narrative-ocg-action {
    -webkit-box-flex: 1;
        -ms-flex: 1 1 calc(50% - 4px);
            flex: 1 1 calc(50% - 4px);
  }

  .narrative-ocg-editor--mobile .narrative-ocg-action {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 78px;
            flex: 0 0 78px;
  }

  .narrative-ocg-details-dialog {
    border-radius: 10px;
    max-height: calc(100vh - 24px);
    max-width: calc(100vw - 24px);
  }

  .narrative-ocg-details-dialog__content {
    min-height: 260px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/features/narrativeOcg/components/narrativeOcg.css"],"names":[],"mappings":"AAAA;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;qCAEmC;UAFnC;;qCAEmC;EACnC,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;mCAEmC;AACnC;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;EACtB,SAAS;EACT,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,gDAAwC;UAAxC,wCAAwC;EACxC,8BAAsB;UAAtB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,QAAQ;EACR,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAW;MAAX,iBAAW;UAAX,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,8BAAsB;UAAtB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAgB;UAAhB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iDAAyC;UAAzC,yCAAyC;EACzC,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAoB;MAApB,oBAAoB;EACpB,8BAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB;;qCAEmC;UAFnC;;qCAEmC;EACnC,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0EAA0E;EAC1E,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,8BAAsB;UAAtB,sBAAsB;EACtB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uCAA+B;UAA/B,+BAA+B;EAC/B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kDAA0C;UAA1C,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAAsB;UAAtB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,YAAY;EACZ,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,sDAA8C;UAA9C,8CAA8C;EAC9C,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,yCAA8B;EAA9B,wCAA8B;MAA9B,kCAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,qBAAiB;MAAjB,iBAAiB;EACjB,gCAAoC;MAApC,6BAAoC;UAApC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,qBAAiB;MAAjB,iBAAiB;AACnB;;AAEA;;;EAGE,8BAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAe;QAAf,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,mBAAyB;QAAzB,6BAAyB;YAAzB,yBAAyB;EAC3B;;EAEA;IACE,mBAAc;QAAd,kBAAc;YAAd,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".description-editor-container {\n  box-sizing: border-box !important;\n  overflow: visible !important;\n}\n\n.description-editor-container [contenteditable] {\n  outline: none !important;\n  white-space: pre-wrap !important;\n  word-break: break-word !important;\n}\n\n.narrative-ocg-editor {\n  background: #fff;\n  border: 1px solid #865bdf;\n  border-radius: 10px;\n  box-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.3),\n    0 2px 6px 2px rgba(0, 0, 0, 0.15);\n  box-sizing: border-box;\n  color: #333;\n  overflow: hidden;\n  position: relative;\n}\n\n/* The grid editor is already outlined by the purple narrative border. Remove\n   the Kendo Popup chrome and the editor shadow so it does not render a second,\n   gray frame around that border. */\n.narrative-editor-popup.k-popup {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n}\n\n.narrative-editor-popup .narrative-ocg-editor {\n  box-shadow: none;\n}\n\n.narrative-ocg-editor--error {\n  border-color: #b3261e;\n}\n\n.narrative-ocg-editor--warning {\n  border-color: #ffa007;\n}\n\n.narrative-ocg-editor__topbar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 4px 8px 0;\n}\n\n.narrative-ocg-icon-button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  color: #333;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 16px;\n  height: 24px;\n  justify-content: center;\n  line-height: 1;\n  padding: 0;\n  width: 24px;\n}\n\n.narrative-ocg-editor__field {\n  background: #fff;\n  border: 0;\n  border-radius: 4px;\n  margin: 12px 12px 0;\n  min-height: 180px;\n  padding: 10px;\n  position: relative;\n}\n\n.narrative-ocg-editor__loading {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: inherit;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n}\n\n.narrative-ocg-editor__loading img {\n  display: block;\n  height: 120px;\n  width: 120px;\n}\n\n.narrative-ocg-editor__loading-text {\n  color: #141414;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 30px;\n}\n\n.narrative-ocg-editor__field .editor-content {\n  border: 0 !important;\n  font-size: 14px !important;\n  letter-spacing: 0 !important;\n  line-height: 1.42 !important;\n  min-height: 160px !important;\n  padding: 0 !important;\n}\n\n.narrative-ocg-editor__toolbar {\n  padding: 0 12px 4px;\n}\n\n.narrative-ocg-editor__toolbar-row {\n  align-items: center;\n  display: flex;\n  height: 36px;\n  justify-content: space-between;\n  padding: 4px 8px;\n}\n\n.narrative-ocg-editor__toolbar-left,\n.narrative-ocg-editor__toolbar-right {\n  align-items: center;\n  display: inline-flex;\n}\n\n.narrative-ocg-editor__toolbar-left {\n  gap: 16px;\n  min-width: 0;\n}\n\n.narrative-ocg-badges {\n  align-items: center;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.narrative-ocg-badge {\n  align-items: center;\n  backdrop-filter: blur(3px);\n  border: 1px solid transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 10px;\n  font-weight: 400;\n  height: 22px;\n  justify-content: center;\n  letter-spacing: 0.5px;\n  line-height: 1.6;\n  padding: 3px 7px;\n  white-space: nowrap;\n}\n\n.narrative-ocg-badge .k-button-text > span {\n  border-bottom: 1px solid #fff;\n  line-height: 1.2;\n}\n\n.narrative-ocg-badge--error {\n  background: #b3261e !important;\n  border-color: #b3261e !important;\n  color: #fff;\n}\n\n.narrative-ocg-badge--warning {\n  background: #ffa007 !important;\n  border-color: #ffa007 !important;\n  color: #fff;\n}\n\n.narrative-ocg-panel {\n  border-bottom: 1px solid transparent;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  margin: 0 -1px -1px;\n  min-height: 125px;\n  padding: 10px 20px 18px;\n  position: relative;\n}\n\n.narrative-ocg-panel--ai {\n  background: #f4f2ff;\n  color: #865bdf;\n}\n\n.narrative-ocg-panel--error {\n  background: #f5f5f5;\n  border-color: #b3261e;\n  color: #b3261e;\n}\n\n.narrative-ocg-panel--warning {\n  background: #f5f5f5;\n  border-color: #ffa007;\n  color: #ffa007;\n}\n\n.narrative-ocg-panel--checking {\n  background: #f7f7f7;\n  color: #333;\n}\n\n.narrative-ocg-panel--error::before,\n.narrative-ocg-panel--warning::before {\n  background: currentColor;\n  content: '';\n  height: 17px;\n  left: 3px;\n  position: absolute;\n  top: 9px;\n  width: 2px;\n}\n\n.narrative-ocg-panel__title {\n  font-size: 12px;\n  line-height: 1.33;\n  letter-spacing: 0.5px;\n  margin-bottom: 0;\n}\n\n.narrative-ocg-panel__message {\n  color: #333;\n  font-size: 12px;\n  line-height: 18px;\n  margin-bottom: 8px;\n}\n\n.narrative-ocg-panel__body {\n  color: #333;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  line-height: 16px;\n  min-height: 32px;\n  max-height: 100px;\n  white-space: pre-wrap;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n.narrative-ocg-diff--removed {\n  color: #ca2921;\n  font-weight: 700;\n  text-decoration: line-through;\n}\n\n.narrative-ocg-diff--added {\n  color: #339858;\n  font-weight: 700;\n}\n\n.narrative-ocg-panel__footer {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.narrative-ocg-panel__view-switch {\n  align-items: center;\n  background: #fafafa;\n  border-radius: 34.286px;\n  display: inline-flex;\n  gap: 8px;\n  height: 26px;\n  justify-content: center;\n  padding: 0 10px;\n  width: 69px;\n}\n\n.narrative-ocg-panel__view-button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  display: inline-flex;\n  height: 14px;\n  justify-content: center;\n  padding: 0;\n  width: 14px;\n}\n\n.narrative-ocg-panel__view-button img {\n  display: block;\n  height: 14px;\n  width: 14px;\n}\n\n.narrative-ocg-panel__view-divider {\n  background: #cac4d0;\n  display: inline-flex;\n  height: 6px;\n  width: 1px;\n}\n\n.narrative-ocg-panel__actions .k-button-text {\n  align-items: center;\n  display: flex;\n}\n\n.narrative-ocg-panel__actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.narrative-ocg-action {\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 9999px;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 14px;\n  font-weight: 400;\n  gap: 6px;\n  height: 32px;\n  justify-content: center;\n  letter-spacing: 0.1px;\n  line-height: 1.42;\n  min-width: 78px;\n  padding: 0 17px;\n  white-space: nowrap;\n}\n\n.narrative-ocg-action:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.narrative-ocg-action--loading {\n  opacity: 0.75;\n}\n\n.narrative-ocg-action--secondary {\n  background: #fff;\n  border-color: #d9d9d9;\n  color: #333;\n}\n\n.narrative-ocg-action--primary {\n  background: #333;\n  color: #fff;\n  letter-spacing: 0.25px;\n  min-width: 78px;\n  padding: 0 12px 2px;\n}\n\n.narrative-ocg-validation-bars {\n  box-sizing: border-box;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.narrative-ocg-validation-bar {\n  align-items: center;\n  box-sizing: border-box;\n  color: #fff;\n  display: flex;\n  font-size: 14px;\n  font-weight: 400;\n  gap: 10px;\n  height: 38px;\n  justify-content: space-between;\n  letter-spacing: 0.25px;\n  line-height: 20px;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  padding: 10px 20px;\n  width: 100%;\n}\n\n.narrative-ocg-validation-bar--error {\n  background: #dd352c;\n}\n.narrative-ocg-validation-bar--warning {\n  background: #ffa007;\n}\n\n.narrative-ocg-validation-bar__icon {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 16px;\n  height: 16px;\n  justify-content: center;\n  position: relative;\n  width: 16px;\n}\n\n.narrative-ocg-validation-bar__icon img {\n  height: 16px;\n  inset: 0;\n  position: absolute;\n  width: 16px;\n}\n\n.narrative-ocg-validation-bar__divider {\n  background: rgba(255, 255, 255, 0.8);\n  flex: 0 0 auto;\n  height: 20px;\n  width: 1px;\n}\n\n.narrative-ocg-validation-bar > strong {\n  flex: 0 0 auto;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.narrative-ocg-validation-bar__rule-container {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.narrative-ocg-validation-bar__rule {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.narrative-ocg-validation-bar__view {\n  background: #fff !important;\n  border: 0 !important;\n  border-radius: 999px;\n  box-sizing: border-box;\n  color: #141414 !important;\n  cursor: pointer;\n  display: grid;\n  flex: 0 0 auto;\n  font-family: inherit;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  height: 26px;\n  letter-spacing: normal;\n  line-height: 16px !important;\n  min-width: 70px !important;\n  padding: 0 12px !important;\n  place-items: center;\n  text-align: center;\n  white-space: nowrap;\n  width: 70px;\n}\n\n.narrative-ocg-validation-bar__view:hover,\n.narrative-ocg-validation-bar__view:focus {\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.narrative-ocg-field-suggestion {\n  display: inline-flex;\n  position: absolute;\n  right: 28px;\n  top: 8px;\n  z-index: 10;\n}\n\n.narrative-ocg-field-suggestion__trigger {\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 24px;\n  outline: none;\n  padding: 3px;\n  width: 24px;\n}\n\n.narrative-ocg-field-suggestion__trigger:hover,\n.narrative-ocg-field-suggestion__trigger:focus,\n.narrative-ocg-field-suggestion__trigger:active {\n  background: transparent;\n  box-shadow: none;\n  outline: none;\n}\n\n.narrative-ocg-field-suggestion__trigger img {\n  height: 18px;\n  width: 18px;\n}\n\n.narrative-ocg-field-suggestion__icon--hover {\n  display: none;\n}\n\n.narrative-ocg-field-suggestion__trigger:hover\n  .narrative-ocg-field-suggestion__icon--default,\n.narrative-ocg-field-suggestion__trigger:focus\n  .narrative-ocg-field-suggestion__icon--default {\n  display: none;\n}\n\n.narrative-ocg-field-suggestion__trigger:hover\n  .narrative-ocg-field-suggestion__icon--hover,\n.narrative-ocg-field-suggestion__trigger:focus\n  .narrative-ocg-field-suggestion__icon--hover {\n  display: block;\n}\n\n.narrative-ocg-field-suggestion__popover {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  color: #333;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  left: -73px;\n  min-width: 250px;\n  padding: 26px;\n  position: absolute;\n  top: 32px;\n  z-index: 1000;\n}\n\n.narrative-ocg-field-suggestion__popover strong {\n  color: #b3261e;\n}\n.narrative-ocg-field-suggestion__values span {\n  color: #ca2921;\n  text-decoration: line-through;\n}\n.narrative-ocg-field-suggestion__values b {\n  color: #339858;\n}\n\n.narrative-ocg-field-suggestion__accept {\n  align-self: flex-end;\n  flex: 0 0 auto !important;\n  height: 32px !important;\n  min-height: 32px !important;\n  min-width: 104px;\n  padding: 0 17px !important;\n  width: auto !important;\n}\n\n.narrative-ocg-field-suggestion__accept-icon {\n  display: block;\n  flex: 0 0 16px;\n  height: 16px !important;\n  width: 16px !important;\n}\n\n.narrative-ocg-dialog-backdrop {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  padding: 20px;\n  position: fixed;\n  z-index: 20000;\n}\n\n.narrative-ocg-details-dialog {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.3),\n    0 4px 8px 3px rgba(0, 0, 0, 0.15);\n  max-height: calc(100vh - 40px);\n  max-width: calc(100vw - 40px);\n  overflow: hidden;\n  width: 720px;\n}\n\n.narrative-ocg-details-dialog--maximized {\n  border-radius: 0;\n  height: 100vh;\n  max-height: 100vh;\n  max-width: 100vw;\n  width: 100vw;\n}\n\n.narrative-ocg-details-dialog__icon-button {\n  align-items: center;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  padding: 12px;\n  width: 40px;\n}\n\n.narrative-ocg-details-dialog__icon-button img {\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n\n.narrative-ocg-reference-window .k-window-title {\n  width: 100%;\n}\n\n.custom-floating-window.k-window {\n  /* Drop Kendo's default 1px #dee2e6 window border; the shadow frames it. */\n  border: 0;\n  max-height: 100vh;\n  max-width: 100vw;\n}\n\n.custom-floating-window.k-window .k-window-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n}\n\n.custom-floating-window__body {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.custom-floating-window-title {\n  width: 100%;\n}\n\n.custom-floating-window-actions {\n  align-items: center;\n  display: inline-flex;\n  gap: 0;\n}\n\n.custom-floating-window-action {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  padding: 0;\n  width: 40px;\n}\n\n.custom-floating-window-action img {\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n\n.narrative-ocg-details-dialog__content {\n  box-sizing: border-box;\n  min-height: 387px;\n  overflow: auto;\n  padding: 24px 22px;\n}\n\n.narrative-ocg-details-dialog--maximized\n  .narrative-ocg-details-dialog__content {\n  height: calc(100vh - 80px);\n  min-height: 0;\n}\n\n.narrative-ocg-detail-item {\n  color: #141414;\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  line-height: 1.42;\n  margin-bottom: 12px;\n}\n\n.narrative-ocg-detail-item__description {\n  padding-left: 10px;\n}\n\n.narrative-ocg-mobile-screen .narrative-ocg-detail-item {\n  color: #141414;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 16px;\n  letter-spacing: 0.5px;\n  line-height: 1.35;\n  margin-bottom: 16px;\n}\n\n.narrative-ocg-mobile-screen .narrative-ocg-detail-item__description {\n  padding-left: 10px;\n}\n\n.narrative-ocg-mobile-screen .narrative-ocg-summary-content,\n.narrative-ocg-mobile-screen .narrative-ocg-summary-rule {\n  color: #333;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  line-height: 1.5;\n}\n\n.narrative-ocg-summary-content {\n  color: #333;\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.narrative-ocg-summary-empty {\n  color: #666;\n  font-size: 14px;\n  line-height: 1.42;\n  padding-top: 50px;\n  text-align: center;\n}\n\n.narrative-ocg-summary-rules {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.narrative-ocg-summary-rule {\n  color: #141414;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.narrative-ocg-summary-rule__name {\n  font-weight: 700;\n}\n\n.narrative-ocg-summary-rule__condition {\n  margin-top: 2px;\n}\n\n.narrative-ocg-mobile-screen {\n  background: #f8f9ff;\n  color: #141414;\n  display: flex;\n  flex-direction: column;\n  inset: 0;\n  position: fixed;\n  z-index: 2147483600;\n}\n\n.narrative-ocg-mobile-screen__header {\n  align-items: flex-end;\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 0 96px;\n  height: 96px;\n  justify-content: space-between;\n  padding: 0 24px 16px;\n  position: relative;\n}\n\n.narrative-ocg-mobile-screen--reference .narrative-ocg-mobile-screen__header {\n  background: #865bdf;\n}\n\n.narrative-ocg-mobile-screen--error .narrative-ocg-mobile-screen__header {\n  background: #b3261e;\n}\n\n.narrative-ocg-mobile-screen--warning .narrative-ocg-mobile-screen__header {\n  background: #ffa007;\n}\n\n.narrative-ocg-mobile-screen__title {\n  align-items: center;\n  color: #fff;\n  display: inline-flex;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  gap: 10px;\n  justify-content: center;\n  left: 56px;\n  line-height: 32px;\n  min-width: 0;\n  position: absolute;\n  right: 56px;\n  top: 48px;\n}\n\n.narrative-ocg-mobile-screen__title img {\n  display: block;\n  flex: 0 0 auto;\n  height: 24px;\n  width: 24px;\n}\n\n.narrative-ocg-mobile-screen__title span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.narrative-ocg-mobile-screen__close {\n  align-items: center;\n  display: inline-flex;\n  height: 32px;\n  justify-content: center;\n  position: absolute;\n  right: 24px;\n  top: 48px;\n  width: 32px;\n}\n\n.narrative-ocg-mobile-screen__close img {\n  display: block;\n  filter: brightness(0) invert(1);\n  height: 32px;\n  width: 32px;\n}\n\n.narrative-ocg-mobile-screen__body {\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 16px 24px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.narrative-ocg-mobile-document {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 100%;\n  min-height: 0;\n}\n\n.narrative-ocg-mobile-document__preview {\n  background: #fff;\n  border: 0;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.narrative-ocg-mobile-document__preview .k-pdf-viewer {\n  border: 0;\n  height: 100%;\n}\n\n.narrative-ocg-mobile-document__preview .k-pdf-viewer-canvas {\n  flex: 1 1 auto;\n  height: 100%;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.narrative-ocg-mobile-document__preview .k-pdf-viewer-canvas,\n.narrative-ocg-mobile-document__preview .k-pdf-viewer-pages {\n  min-height: 0;\n}\n\n.narrative-ocg-mobile-document__download {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #dadada;\n  border-radius: 24px;\n  box-sizing: border-box;\n  color: #333;\n  display: inline-flex;\n  flex: 0 0 48px;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  height: 48px;\n  justify-content: center;\n  line-height: normal;\n  text-decoration: none;\n  width: 100%;\n}\n\n.narrative-ocg-editor--mobile {\n  border-color: #e8e8e8 !important;\n  border-radius: 6px;\n  box-shadow: none;\n  overflow: visible;\n  width: 100%;\n}\n\n.narrative-ocg-editor--mobile:focus-within {\n  box-shadow: 0 4px 7.5px rgba(0, 0, 0, 0.2);\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__field {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  box-sizing: border-box;\n  margin: 8px 8px 0;\n  min-height: 137px;\n  padding: 16px;\n}\n\n.narrative-ocg-editor--mobile:not(.narrative-ocg-editor--error):not(\n    .narrative-ocg-editor--warning\n  ):focus-within\n  .narrative-ocg-editor__field {\n  border-color: #865bdf;\n}\n\n.narrative-ocg-editor--mobile.narrative-ocg-editor--error\n  .narrative-ocg-editor__field {\n  border-color: #b3261e;\n}\n\n.narrative-ocg-editor--mobile.narrative-ocg-editor--warning\n  .narrative-ocg-editor__field {\n  border-color: #ffa007;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__field textarea,\n.narrative-ocg-editor--mobile .narrative-ocg-editor__field .k-input-inner,\n.narrative-ocg-editor--mobile .narrative-ocg-editor__field .editor-content {\n  font-size: 16px !important;\n  letter-spacing: 0 !important;\n  line-height: normal !important;\n  min-height: 103px !important;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar {\n  padding: 10px 24px;\n  position: relative;\n  z-index: 1;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-row {\n  align-items: center;\n  height: 22px;\n  justify-content: flex-start;\n  min-height: 22px;\n  padding: 0;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-left {\n  align-items: center;\n  gap: 8px;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-editor__toolbar-right {\n  align-items: center;\n  margin-left: auto;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-badges {\n  flex: 0 0 auto;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel {\n  border-color: #e8e8e8;\n  border-radius: 0 0 6px 6px;\n  box-shadow: 0 4.36px 4.36px rgba(0, 0, 0, 0.1);\n  margin: 0;\n  min-height: 125px;\n  padding: 16px 24px;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel::before {\n  height: 19px;\n  left: 3px;\n  top: 16px;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel__title {\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-bottom: 0;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel__body {\n  font-size: 12px;\n  line-height: 1.33;\n  min-height: 32px;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel__footer--mobile {\n  align-items: flex-end;\n  flex-direction: row !important;\n  gap: 12px;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel__actions--mobile {\n  flex: 0 0 auto;\n  flex-wrap: nowrap;\n  justify-content: flex-end !important;\n  width: auto !important;\n}\n\n.narrative-ocg-editor--mobile .narrative-ocg-panel__icon-actions {\n  flex: 0 0 auto;\n  flex-wrap: nowrap;\n}\n\n.narrative-ocg-editor--mobile\n  .narrative-ocg-panel__actions--mobile\n  .narrative-ocg-action {\n  flex: 0 0 78px !important;\n}\n\n.narrative-ocg-mobile-icon-action img {\n  display: block;\n  max-height: 16px;\n  max-width: 16px;\n}\n\n@media (max-width: 640px) {\n  .narrative-ocg-editor__toolbar-row {\n    align-items: flex-start;\n    height: auto;\n    min-height: 36px;\n  }\n\n  .narrative-ocg-editor__toolbar-left {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .narrative-ocg-panel {\n    padding: 10px 16px 16px 20px;\n  }\n\n  .narrative-ocg-panel__footer {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .narrative-ocg-panel__actions {\n    justify-content: flex-start;\n    width: 100%;\n  }\n\n  .narrative-ocg-action {\n    flex: 1 1 calc(50% - 4px);\n  }\n\n  .narrative-ocg-editor--mobile .narrative-ocg-action {\n    flex: 0 0 78px;\n  }\n\n  .narrative-ocg-details-dialog {\n    border-radius: 10px;\n    max-height: calc(100vh - 24px);\n    max-width: calc(100vw - 24px);\n  }\n\n  .narrative-ocg-details-dialog__content {\n    min-height: 260px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
